var render = function render(){var _vm=this,_c=_vm._self._c;return _c('McButton',{attrs:{"variant":"secondary","icon":"icon-fill_share","text":_vm.hideText ? '' : _vm.computedText,"disabled":_vm.shareTrackDisabled,"size":_vm.size,"displayTooltip":true,"tooltipText":_vm.tooltipText},on:{"click":function($event){return _vm.$emit('click', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }